<template>
  <div>
    <el-dialog :visible.sync="visible" width="900px" title="充值活动" @close="handleClose" append-to-body>
      <div>
        <el-button type="primary" @click="showAddDialog" size="small" round>+ 添加充值活动</el-button>
        <el-table :data="list" style="width: 100%; margin-top: 20px;" v-loading="listLoading">
          <el-table-column prop="name" label="充值金额" />
          <el-table-column prop="getBalance" label="获得余额额度" />
          <el-table-column prop="remainingQuota" label="剩余名额" />
          <el-table-column prop="state" label="状态" >
            <template slot-scope="{row}">
              <el-tag :type="row.state === 1 ? 'success' : 'danger'">
                {{ row.state === 1 ? '已上架' : '已下架' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-link type="primary" @click="removeAdmin(scope.$index)">移除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="formVisible" width="600px" title="添加充值活动" @close="handleClose" append-to-body>
      <el-form :model="form" label-width="80px">
        <el-form-item label="充值套餐" required>
          <el-select v-model="form.rechargeActivityId" placeholder="请选择充值套餐" style="width: 100%;">
            <el-option v-for="item in activityList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="剩余名额" required>
          <el-input v-model="form.remainingQuota" placeholder="请输入剩余名额" style="width: 100%;" />
        </el-form-item>
        
      </el-form>
      <div style="text-align: right; margin-top: 30px;">
        <el-button @click="formVisible = false">取消</el-button>
        <el-button type="primary" @click="doCreate()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import liveManageApi from '@/api/live/liveManage'

export default {
  props: {
    rowItem: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      visible: false,
      formVisible: false,
      list: [],
      listLoading: false,
      form: {
        rechargeActivityId: null,
        remainingQuota: null,
        liveId: null
      },
      activityList: [],
      query: {
        liveId: null
      }
    }
  },
  methods: {
    handleShow(row) {
      console.log('recharge.vue handleShow 接收到的 row:', row)
      // 接收父组件传递的 row 参数
      if (row) {
        this.rowItem = row
        console.log('recharge.vue 设置后的 rowItem:', this.rowItem)
        console.log('recharge.vue rowItem.livePO:', this.rowItem.livePO)
        console.log('recharge.vue rowItem.livePO.id:', this.rowItem.livePO && this.rowItem.livePO.id)
      }
      this.doQueryList()
      this.visible = true
    },
    handleClose() {
      this.visible = false
    },
    doQueryList() {
      this.listLoading = true
      console.log('doQueryList 中的 this.rowItem:', this.rowItem)
      console.log('doQueryList 中的 this.rowItem.livePO:', this.rowItem && this.rowItem.livePO)
      console.log('doQueryList 中的 this.rowItem.livePO.id:', this.rowItem && this.rowItem.livePO && this.rowItem.livePO.id)
      
      // 添加安全检查
      if (!this.rowItem || !this.rowItem.livePO || !this.rowItem.livePO.id) {
        console.error('rowItem.livePO.id 不存在')
        this.listLoading = false
        return Promise.resolve()
      }
      this.query.liveId = this.rowItem.livePO.id
      return liveManageApi.fetchListLiveGoods(this.query).then(res => {
        console.log('充值活动接口返回数据:', res);
        // 过滤出 type: 3 的数据
        this.list = res.data.filter(item => item.type === 3);
        console.log('充值活动列表数据:', this.list);
      }).finally(() => {
        this.listLoading = false
      })
    },
    getActivityList() {
      // 添加安全检查
      if (!this.rowItem || !this.rowItem.livePO || !this.rowItem.livePO.id) {
        console.error('rowItem.livePO.id 不存在')
        return
      }
      // 使用直播商品接口获取充值活动数据
      const query = { liveId: this.rowItem.livePO.id }
      liveManageApi.fetchListLiveGoods(query).then(res => {
        // 过滤出 type: 3 的数据作为充值套餐选项
        this.activityList = res.data.filter(item => item.type === 3)
      })
    },
    showAddDialog() {
      this.getActivityList()
      this.formVisible = true
    },
    removeAdmin(row) {
      this.$common.confirm('确认移除该充值活动？')
        .then(() => {
          return liveManageApi.deleteLiveGoods({ id: row.id })
        })
        .then(() => {
          this.$common.showMsg('success', '移除成功')
          this.doQueryList()
        })
    },
    doCreate() {
      // 添加安全检查
      if (!this.rowItem || !this.rowItem.livePO || !this.rowItem.livePO.id) {
        console.error('rowItem.livePO.id 不存在')
        this.$message.error('直播ID不存在，无法添加充值活动')
        return
      }
      // 添加当前选中的直播ID
      const params = {
        ...this.form,
        liveId: this.rowItem.livePO.id
      }
      liveManageApi.createLiveGoodsActivity(params).then((data) => {
        this.postCallback(data)
      })
    },
    postCallback(response) {
      this.$message.success('操作成功')
      this.formVisible = false;
      // 刷新充值活动列表
      this.doQueryList()
      this.$emit('created')
    },
  }
}
</script>